import { BVTConstants } from './BVTConstants';

/**
 * Utility functions for session management
 */
export const sessionUtils = {
  /**
   * Get formatted time until logout
   * @param {number} timeUntilLogout - Time in milliseconds
   * @returns {string} Formatted time string
   */
  formatTimeUntilLogout: (timeUntilLogout) => {
    if (timeUntilLogout <= 0) return '0 minutes';
    
    const minutes = Math.floor(timeUntilLogout / 1000 / 60);
    const seconds = Math.floor((timeUntilLogout / 1000) % 60);
    
    if (minutes > 0) {
      return `${minutes} minute${minutes !== 1 ? 's' : ''}${seconds > 0 ? ` ${seconds} second${seconds !== 1 ? 's' : ''}` : ''}`;
    }
    return `${seconds} second${seconds !== 1 ? 's' : ''}`;
  },

  /**
   * Check if session is about to expire
   * @param {number} timeUntilLogout - Time in milliseconds
   * @returns {boolean} True if session is about to expire
   */
  isSessionAboutToExpire: (timeUntilLogout) => {
    return timeUntilLogout <= BVTConstants.SESSION_WARNING_THRESHOLD;
  },

  /**
   * Get session timeout configuration
   * @returns {object} Session timeout configuration
   */
  getSessionConfig: () => ({
    inactivityTimeout: BVTConstants.SESSION_INACTIVITY_TIMEOUT,
    warningThreshold: BVTConstants.SESSION_WARNING_THRESHOLD,
    inactivityTimeoutMinutes: BVTConstants.SESSION_INACTIVITY_TIMEOUT / 1000 / 60,
    warningThresholdMinutes: BVTConstants.SESSION_WARNING_THRESHOLD / 1000 / 60
  }),

  /**
   * Log session activity for debugging
   * @param {string} activity - Activity description
   * @param {number} timeUntilLogout - Time until logout
   */
  logSessionActivity: (activity, timeUntilLogout) => {
    if (process.env.NODE_ENV === 'development') {
      console.log(`[Session Activity] ${activity} - Time until logout: ${sessionUtils.formatTimeUntilLogout(timeUntilLogout)}`);
    }
  }
}; 